import React from 'react';
import ReactMarkdown from 'react-markdown';

/**
 * Renders plan markdown exactly like the end-user PlanCompletionCelebration preview:
 * - Splits out the <!-- HEADER_START --> ... <!-- HEADER_END --> block
 * - Renders header with special typography
 * - Renders body with the same markdown component overrides
 */
const PlanMarkdownContent = ({ content = '' }) => {
  const headerMatch = content.match(/<!-- HEADER_START -->([\s\S]*?)<!-- HEADER_END -->/);
  const headerContent = headerMatch ? headerMatch[1] : '';
  const bodyContent = content.replace(/<!-- HEADER_START -->[\s\S]*?<!-- HEADER_END -->/, '');

  return (
    <>
      {headerContent && (
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <ReactMarkdown
            components={{
              h1: ({ children }) => <h1 style={{ marginBottom: '0.5rem' }}>{children}</h1>,
              h3: ({ children }) => <h3 style={{ marginBottom: '0.25rem', fontWeight: 500 }}>{children}</h3>,
              h4: ({ children }) => <h4 style={{ marginBottom: '1rem', fontWeight: 400, color: '#6b7280' }}>{children}</h4>,
              p: ({ children }) => <p style={{ marginBottom: '0.25rem' }}>{children}</p>,
            }}
          >
            {headerContent}
          </ReactMarkdown>
        </div>
      )}
      <ReactMarkdown
        components={{
          hr: () => <hr style={{ margin: '1.5rem 0', borderColor: '#e5e7eb' }} />,
          p: ({ children }) => <p style={{ marginBottom: '1rem' }}>{children}</p>,
          strong: ({ children }) => <strong style={{ display: 'block', marginTop: '1.5rem' }}>{children}</strong>,
          em: ({ children }) => <em style={{ display: 'block', marginBottom: '0.5rem', color: '#4b5563' }}>{children}</em>,
        }}
      >
        {bodyContent}
      </ReactMarkdown>
    </>
  );
};

export default PlanMarkdownContent;



